import { ColumnDescription } from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faDownload,
    faEnvelope,
    faEye,
    faPlus,
} from "@fortawesome/free-solid-svg-icons";

import { useAtendimentoPage } from "../../../Context/AtendimentoPage";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import Swal from "sweetalert2";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { InserirEnvelopeController } from "../../../Controllers/Geral/Envelopes/EnvelopesControllers";
import { useState } from "react";
import Table from "../../../Components/Table";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import {
    DownloadEnvelopeController,
    ListarEnvelopesCasoController,
    ReenviarEnvelopeController,
} from "../../../Controllers/Geral/Email/EmailController";
import { IListarEnvelopesCaso } from "../../../Interfaces/Geral/Email/EmailInterface";
import VisualizarEnvelope from "./VisualizarEnvelope";
import { useModuloInfo } from "../../../Context/ModuloInfo";
import { saveAs } from "file-saver";
import { Spinner } from "../../../Components/Loding/SpinnerPadrao";
import EnviarEnvelopeModal from "../../../Pages/Vendas/EnvelopesGerados/SelecionarEnvelopeModal";

export default function Envelopes() {
    const [modal, setModal] = useState<IComponentModal>();
    const [show, setShow] = useState(false);

    const { ID_CASO } = useAtendimentoPage();
    const { id } = useModuloInfo();

    const { execute: executeInserirEnvelope, loading: loadingInserirEnvelope } =
        useAsyncCallback(InserirEnvelopeController);

    const { execute: DownloadEnvelope, loading: DownloadEnvelopeLoading } =
        useAsyncCallback(DownloadEnvelopeController);

    const { execute: ReenviarEnvelope, loading: ReenviarEnvelopeLoading } =
        useAsyncCallback(ReenviarEnvelopeController);

    const {
        value: lstEnvelopes,
        loading: lstEnvelopesLoading,
        execute: executeListarEnvelopesCaso,
    } = useAsyncEffect(async () => {
        if (ID_CASO) {
            return ListarEnvelopesCasoController(ID_CASO);
        }
    }, [ID_CASO]);

    const columns: Array<ColumnDescription<IListarEnvelopesCaso>> = [
        {
            dataField: "DS_GUID",
            text: "GUID",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "DS_NOME_ENVELOPE",
            text: "Nome do Envelope",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "DT_ENVIO",
            text: "Data de Envio",
            align: "center",
            headerAlign: "center",
            formatter: (cell) => {
                return cell ? moment(cell).format("DD/MM/YYYY HH:mm") : "-";
            },
        },
        {
            dataField: "DS_STATUS",
            text: "Status",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "DS_USUARIO_RESPONSAVEL",
            text: "Responsável",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "acoes",
            text: "Ações",
            formatter: (cell, row) => (
                <div className="d-flex gap-4">
                    <OverlayTrigger
                        overlay={
                            <Tooltip id="tooltip-download">Download</Tooltip>
                        }
                    >
                        <button
                            className="btn btn-md btn-outline-primary mx-2"
                            onClick={() => handleDownload(row)}
                            disabled={DownloadEnvelopeLoading}
                        >
                            {DownloadEnvelopeLoading ? (
                                <Spinner size="sm" />
                            ) : (
                                <FontAwesomeIcon icon={faDownload} />
                            )}
                        </button>
                    </OverlayTrigger>
                    <OverlayTrigger
                        overlay={
                            <Tooltip id="tooltip-reenviar">Reenviar</Tooltip>
                        }
                    >
                        <button
                            className="btn btn-md btn-outline-success mx-2"
                            onClick={() => handleReenviar(row)}
                        >
                            <FontAwesomeIcon icon={faEnvelope} />
                        </button>
                    </OverlayTrigger>
                    <OverlayTrigger
                        overlay={
                            <Tooltip id="tooltip-visualizar">
                                Visualizar
                            </Tooltip>
                        }
                    >
                        <button
                            className="btn btn-md btn-outline-info mx-2"
                            onClick={() => handleVisualizar(row)}
                        >
                            <FontAwesomeIcon icon={faEye} />
                        </button>
                    </OverlayTrigger>
                </div>
            ),
        },
    ];

    const handleVisualizar = (row: IListarEnvelopesCaso) => {
        setShow(true);
        setModal({
            headerComponent: `${row.DS_NOME_ENVELOPE}`,
            IconHeader: faEye,
            Component: () => (
                <VisualizarEnvelope
                    id_envelope={row.ID_ENVELOPE}
                    setShow={setShow}
                />
            ),
            size: "xl",
        });
    };

    const handleDownload = (row: IListarEnvelopesCaso) => {
        DownloadEnvelope(row.ID_ENVELOPE, id ?? 0).then((res) => {
            const byteCharacters = atob(res.IM_DOCUMENTO);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            saveAs(
                new Blob([byteArray], {
                    type: "application/pdf",
                }),
                `${row.DS_NOME_ENVELOPE}.pdf`
            );
        });
    };

    const handleReenviar = (row: IListarEnvelopesCaso) => {
        Swal.fire({
            title: "Reenviar Envelope?",
            text: "Você deseja reenviar o envelope?",
            icon: "warning",
            showCancelButton: true,
        }).then((result) => {
            if (result.isConfirmed) {
                ReenviarEnvelope(row.ID_ENVELOPE).then(() => {
                    executeListarEnvelopesCaso();
                });
            }
        });
    };

    function handleGerarEnvelope() {
        executeInserirEnvelope({ ID_CASO: ID_CASO }).then((response) => {
            if (response.LST_ENVELOPES?.length > 1) {
                setShow(true);
                setModal({
                    Component: () => (
                        <EnviarEnvelopeModal
                            setModal={setModal}
                            envelopes={response}
                            setShow={setShow}
                        />
                    ),
                    headerComponent: "Envio de Envelopes",
                    IconHeader: faEnvelope,
                });
            }
        });
    }

    return (
        <div className="card card-custom card-stretch pt-5 px-4">
            <div className="d-flex justify-content-between mb-2">
                <h4 className="mb-4">Envelopes</h4>
                <button
                    className="btn btn-md btn-outline-success"
                    disabled={loadingInserirEnvelope}
                    onClick={() => {
                        Swal.fire({
                            title: "Criar Envelope?",
                            text: "Você deseja criar um novo envelope?",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonText: "Sim",
                            cancelButtonText: "Não",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                handleGerarEnvelope();
                            }
                        });
                    }}
                >
                    {loadingInserirEnvelope ? (
                        <Spinner size="sm" />
                    ) : (
                        <FontAwesomeIcon icon={faPlus} />
                    )}{" "}
                    Criar Envelope
                </button>
            </div>

            <Table
                keyField="ID_ENVELOPE"
                key={`${lstEnvelopesLoading}-${DownloadEnvelopeLoading}-${ReenviarEnvelopeLoading}`}
                data={lstEnvelopes ?? []}
                columns={columns}
                noDataIndication={() => (
                    <div className="text-black-50 text-center">
                        Nenhum envelope gerado
                    </div>
                )}
                bordered={false}
                loading={lstEnvelopesLoading}
                noHover
                noSearch
            />

            <ModalComponent
                ModalComponent={modal}
                setShow={setShow}
                show={show}
            />
        </div>
    );
}
